import { Container, Row, Col } from "react-bootstrap";
import "../style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
// import pdf from "../assets/files/mohit_bidikar_cv.pdf";
import TelcoRoadmap from "./Roadmap";

function Home() {
  return (
    <Container>
      <Row>
        <Col className="header">
          {/* <label>
            <h1>
              <strong data-text="Mohit Bidikar">Mohit Bidikar</strong>
            </h1>
          </label>
          <a href={pdf} target="_blank" className="icons" rel="noreferrer">
            <i className="far fa-file-alt icons-dtls"> CV</i>
          </a> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <TelcoRoadmap />
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
